<script setup lang="ts">
  import { useBootstrapModal } from "@/composables/useBootstrapModal";
  import {
      useAuthStore
  } from "@/store/auth";
  import AddReviowModal from '~/components/addReviowModal.vue'
  import { useWarningModal } from "~/composables/useWarningModal";
  import ReportRateModal from "@/components/ReportRateModal.vue";
  import { ref, onMounted, onUnmounted } from 'vue';
  const { showModal } = useWarningModal();

  const showIsRatedWaringModal = () => {
    showModal('لقد قمت بالتقييم مسبقاً','لقد قمت بالتقييم مسبقاً');
  };
  const authStore = useAuthStore();
  const isAuthenticated = computed(() => authStore.isAuthenticated);

  const { openModal: openUserModal } = useBootstrapModal("userModal");
  const { openModal: openRateModal } = useBootstrapModal("add_rate_modal");


  const props = defineProps({
    place: { type: Object, required: true },
    rates: { type: Array, required: true },
    nextPage: Number | null,
    loading: Boolean | false,
    filterText: String | null,
    loadMore: Function, // Accept the function from the parent
    setSort: Function,
    avatarUrl: { type: String, required: true },
    cleanedStoreLink: { type: String, default: '' }
});

  const addReviowModal = ref()

  const openAddRateModal = (placeId) => {
    
    // Set the place id in the modal component using the exposed method.
    if (addReviowModal.value && addReviowModal.value.setPlaceId) {
      addReviowModal.value.setPlaceId(placeId)
    }
    // Use Bootstrap Modal API to show the modal (ensure Bootstrap JS is included)
    openRateModal();
  }
  // For demonstration purposes, assume the user is not logged in.

  // Listen for the "review-added" event from the modal
  const handleReviewAdded = () => {
    // Re-emit the event upward so the page can refresh reviews
    // You can use defineEmits here if PlaceProfile is set up to emit events.
    // For example:
    emit('review-added')
  }

  // Expose any events if needed.
  const emit = defineEmits(['review-added'])

  // In your real app, you might use a composable like useAuth() to check authentication.


const filterOrder = ref(null)


const setFilter = async (order) => {
  filterOrder.value = order
  props.setSort(filterOrder.value)
}

const reportModalRef = ref<InstanceType<typeof ReportRateModal> | null>(null)

const handleReport = (ratingId: String) => {
  
  if (reportModalRef.value) {
    reportModalRef.value.setRatingId(ratingId)
    reportModalRef.value.openModal()
  }
}

// Scroll to top functionality
const showScrollTop = ref(false);

const handleScroll = () => {
  const scrollPosition = window.scrollY;
  const commentHeight = 250; // Approximate height of each comment
  showScrollTop.value = scrollPosition > (commentHeight * 5);
};

const scrollToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: 'smooth'
  });
};

onMounted(() => {
  window.addEventListener('scroll', handleScroll);
});

onUnmounted(() => {
  window.removeEventListener('scroll', handleScroll);
});

</script>

<template>

  

  <div class="latest_comments inside " id="latest_comments_wrap">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-6">
          <div class="section_title">
            <h1>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                <g id="Group_1" data-name="Group 1" transform="translate(-820 -204)">
                  <g id="trend-up_linear" data-name="trend-up/linear" transform="translate(820 204)">
                    <g id="vuesax_linear_trend-up" data-name="vuesax/linear/trend-up">
                      <g id="trend-up">
                        <path id="Vector" d="M7,20h6c5,0,7-2,7-7V7c0-5-2-7-7-7H7C2,0,0,2,0,7v6C0,18,2,20,7,20Z" transform="translate(2 2)" fill="none" stroke="#292d32" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>
                        <path id="Vector-2" data-name="Vector" d="M0,0H24V24H0Z" fill="none" opacity="0"/>
                      </g>
                    </g>
                  </g>
                  <g id="star_linear" data-name="star/linear" transform="translate(825 209)">
                    <g id="vuesax_linear_star" data-name="vuesax/linear/star">
                      <g id="star">
                        <path id="Vector-3" data-name="Vector" d="M5.865.71l.88,1.746a1.086,1.086,0,0,0,.71.521l1.6.263c1.02.169,1.26.9.525,1.627L8.335,6.1a1.071,1.071,0,0,0-.26.9L8.43,8.516c.28,1.205-.365,1.671-1.44,1.041L5.5,8.68a1.089,1.089,0,0,0-.99,0l-1.5.878c-1.07.63-1.72.159-1.44-1.041l.355-1.522a1.071,1.071,0,0,0-.26-.9L.425,4.866c-.73-.724-.5-1.458.525-1.627l1.6-.263a1.088,1.088,0,0,0,.705-.521L4.13.71C4.61-.237,5.39-.237,5.865.71Z" transform="translate(2.001 2.078)" fill="none" stroke="#292d32" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.4"/>
                        <path id="Vector-4" data-name="Vector" d="M0,0H14V14H0Z" fill="none" opacity="0"/>
                      </g>
                    </g>
                  </g>
                </g>
              </svg>

              <span>التقييمات</span>
            </h1>
          </div>
        </div>
        <div class="col-6">
          <div class="more">
            <div class="dropdown dropdown-filter-main">
              <a href="javascript:void(0)" class="section_subtitle dropdown-toggle" data-bs-toggle="modal"
                data-bs-target="#filter_rate_modal">
                <span>فلتر</span>
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="20" viewBox="0 0 22 20">
                  <g id="Glyph" transform="translate(-1 -2)">
                    <path id="Path_123554" data-name="Path 123554"
                          d="M17,5a3,3,0,1,1,3,3,3,3,0,0,1-3-3ZM2,6H14a1,1,0,0,0,0-2H2A1,1,0,0,0,2,6ZM8,9a3,3,0,0,0-2.82,2H2a1,1,0,0,0,0,2H5.18A3,3,0,1,0,8,9Zm14,2H14a1,1,0,0,0,0,2h8a1,1,0,0,0,0-2ZM10,18H2a1,1,0,0,0,0,2h8a1,1,0,0,0,0-2Zm12,0H18.82a3,3,0,1,0,0,2H22a1,1,0,0,0,0-2Z"
                          fill="#292d32"></path>
                  </g>
                </svg>
              </a>

                <!-- <a href="javascript:void(0)" class="section_subtitle dropdown-toggle" id="dropdownMenuButton1"
                 data-bs-toggle="dropdown" aria-expanded="false">
                <span>فلتر</span>
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="20" viewBox="0 0 22 20">
                  <g id="Glyph" transform="translate(-1 -2)">
                    <path id="Path_123554" data-name="Path 123554"
                          d="M17,5a3,3,0,1,1,3,3,3,3,0,0,1-3-3ZM2,6H14a1,1,0,0,0,0-2H2A1,1,0,0,0,2,6ZM8,9a3,3,0,0,0-2.82,2H2a1,1,0,0,0,0,2H5.18A3,3,0,1,0,8,9Zm14,2H14a1,1,0,0,0,0,2h8a1,1,0,0,0,0-2ZM10,18H2a1,1,0,0,0,0,2h8a1,1,0,0,0,0-2Zm12,0H18.82a3,3,0,1,0,0,2H22a1,1,0,0,0,0-2Z"
                          fill="#292d32"></path>
                  </g>
                </svg>
              </a>
              <ul class="dropdown-menu dropdown-menu-start" aria-labelledby="dropdownMenuButton1">
                <li>
                  <a class="dropdown-item place-filter" :class="{ active: filterOrder === '1' }"
                      @click="setFilter('1')">بحسب الأعلى تقييماً</a>
                </li>
                <li>
                  <a class="dropdown-item place-filter" :class="{ active: filterOrder === '2' }"
                      @click="setFilter('2')">بحسب الأكثر تقييماً</a>
                </li>
                <li>
                  <a class="dropdown-item place-filter" :class="{ active: filterOrder === '3' }"
                      @click="setFilter('3')">الأحدث تقييماً</a>
                </li>
                
              </ul> -->
            </div>
          </div>
        </div>
      </div>

      <div class="comments_wrapper" id="place_rate_cont">
        <div class="row" id="place_rates_cont">
          <template v-if="rates.length">
            <RateObject v-for="rate in rates" :filterText="filterText" :userShow="true" :key="rate.id" :rate="rate" @open-report="handleReport" />
          </template>
          <template v-else-if="loading">
            <!-- <div class="col-md-12">
              <div class="item_rate no-rate has-spinner-link-dark loading">
                <div class="item_content">
                  <span class="addRateLink">
                  </span>
                </div>
              </div>
            </div> -->
            <RateObjectPlaceholder v-for="n in 6" :key="n" :userShow="true" :placeShow="false" />
          </template>
          <template v-else>
            <div class="col-md-12">
              <div class="item_rate no-rate">
                <div class="item_content">
                  <span class="addRateLink">
                    لا يوجد تقييم هل تريد
                   
                      <template v-if="isAuthenticated && place.is_rated == false">
                      <a href="javascript:;" 
                        :data-is_rated="false"
                        :data-place_id="place.id"
                        @click="openAddRateModal(place.id)"
                        class="add_rate_btn" id="add_rate_btn">
                        اضافة تقييم ؟
                      </a>
                    </template>
                    <template v-else-if="isAuthenticated && place.is_rated == true">
                      <a href="javascript:;" 
                        @click="showIsRatedWaringModal"
                        class="add_rate_btn" id="add_rate_btn">
                        اضافة تقييم ؟
                      </a>
                    </template>
                    <template v-else>
                        
                      <a href="javascript:;" @click="openUserModal" id="add_rate_btn_login" data-is_place="rate_place" class="add_rate_btn">
                        اضافة تقييم ؟
                      </a>
                    </template>
                  </span>
                </div>
              </div>
            </div>
          </template>
        </div>
        <!-- "Load more" button if needed -->
        <div v-if="nextPage" class="moreLoading">
            <a href="javascript:;" @click="loadMore" class="section_subtitle load-more has-spinner-link" :class="{ 'loading': loading }">
                <div class="button_text">عرض المزيد</div>
            </a>
        </div>


  <!-- Scroll to top button -->
      <button 
        v-show="showScrollTop" 
        @click="scrollToTop" 
        class="scroll-to-top-btn"
        aria-label="Scroll to top"
      >
      <svg id="arrow-circle-up_linear" data-name="arrow-circle-up/linear" xmlns="http://www.w3.org/2000/svg" width="25.876" height="25.876" viewBox="0 0 25.876 25.876">
      <g id="vuesax_linear_frame" data-name="vuesax/linear/frame">
        <g id="frame">
          <path id="Vector" d="M21.563,10.782A10.782,10.782,0,1,1,10.782,0,10.782,10.782,0,0,1,21.563,10.782Z" transform="translate(2.156 2.156)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8"/>
          <path id="Vector-2" data-name="Vector" d="M0,3.8,3.806,0,7.612,3.8" transform="translate(9.132 10.501)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8"/>
          <path id="Vector-3" data-name="Vector" d="M0,0H25.876V25.876H0Z" transform="translate(25.876 25.876) rotate(180)" fill="none" opacity="0"/>
        </g>
      </g>
    </svg>

      </button>

      </div>
    </div>
  </div>

  <ReportRateModal ref="reportModalRef" dir="rtl" />


</template>

<style scoped>
.scroll-to-top-btn {
  position: fixed;
  bottom: 20px;
  right: 20px;
  width: 55px;
  height: 55px;
  border-radius: 16px;
  background-color: #000;
  color: white;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0px 10px 80px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  z-index: 9999;
}

.scroll-to-top-btn:hover {
  background-color: #1a1d20;
  transform: translateY(-2px);
}

.scroll-to-top-btn svg {
  width: 25.876px;
  height: 25.876px;
}

</style>
